<template>
    <div>
        <div class="mcc-dialog-overlay">
            <dialog class="mcc-dialog mcc-dialog--sm mcc-dialog--info" ref="taskHistoryDialog"
                id="taskHistory-dialog">
                <section>
                    <div class="mcc-dialog__header">
                        <h2 class="h4">Task history</h2>
                        <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="taskHistoryCloseHandler()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                    </div>
                    <div class="mcc-dialog__body">
                        
                        <div class="mcc-row">
                            <div class="mcc-col">
                                <mcc-data-table ref="taskHistoryTable" id="taskHistoryTableId"></mcc-data-table>
                            </div>
                        </div>
                    </div>
                    <div class="mcc-dialog__footer">
                        <div class="mcc-button-group mcc-button-group--spaced">
                            <button type="button" class="mcc-button mcc-button--info"
                                @click="taskHistoryCloseHandler()">Ok</button>
                        </div>
                    </div>
                </section>
            </dialog>
        </div>
        <div class="mcc-dialog-overlay">
            <dialog class="mcc-dialog mcc-dialog--xs mcc-dialog--primary" ref="commentsDialog" id="comments-dialog">
                <form novalidate>
                    <section>
                        <div class="mcc-dialog__header">
                            <h2 class="h4">Comments</h2>
                            <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="commentHideHandler()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                        </div>
                        <div class="mcc-dialog__body">
                            <div class="mcc-row">
                                <div class="mcc-col">
                                    <div class="mcc-chat" style="position:relative">
                                        <div v-if="!updateCall" class="spinner-overlay">
                                            <div class="spinner-background"></div>
                                            <div class="spinner-flex">
                                                <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                                    <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                                    <circle cx="25" cy="25" r="20" fill="none" stroke-width="5">
                                                    </circle>
                                                </svg>
                                            </div>
                                        </div>
                                        <div class="mcc-row" v-if="taskObj.isCompleted">
                                            <div class="mcc-col">
                                                <mcc-alert role="alert" class="mcc-alert mcc-alert--warning mcc-alert--compact">
                                                    <mcc-icon name="error" aria-hidden="true"></mcc-icon>
                                                    <strong>Warning!</strong>
                                                    <div>
                                                        <span> Comment cannot be added as task is completed.</span>
                                                    </div>
                                                </mcc-alert>
                                            </div>
                                        </div>
                                        <div class="chatDiv mcc-chat__body" v-if="updateComments">
                                            <div class="mcc-chat__messages" v-for="(comment, index) in comments" :key="index">
                                                <div :class="$store.getters.getUserProfile.username === comment.author ? 'mcc-chat__message mcc-chat__message--sent' : 'mcc-chat__message'">
                                                    <div class="mcc-chat__bubble">
                                                        <div class="mcc-chat__name">{{ comment.author != '' ? comment.author : ' ' }}</div>
                                                        <div class="mcc-chat__text">{{comment.message }}</div>
                                                    </div>
                                                    <div class="mcc-chat__datetime">{{ comment.prettyCreatedTime }}</div>
                                                </div>
                                            </div>
                                            <!-- <div class="mcc-card mu-mt-05" :class="$store.getters.getUserProfile.username === comment.author ? 'mcc-card--primary-soft' : ''" v-for="(comment, index) in comments" :key="index">
                                                <div class="mcc-card__header">
                                                    <h2 class="mcc-card__title">{{ comment.author != '' ? comment.author : ' ' }}</h2>
                                                    <div class="mcc-card__subtitle">{{ comment.prettyCreatedTime }}</div>
                                                </div>
                                                <div class="mcc-card__body">
                                                    <span>{{comment.message }}  </span>
                                                </div>
                                            </div> -->
                                        </div>
                                        <div >
                                            <textarea :disabled="taskObj.isCompleted" name="chatInput" class="form-control summernote" id="chatInputEle" rows="3" placeholder="Type your message"></textarea>
                                        </div>
                                        <div v-if="showError">
                                            <span class="text-danger">Comment is required</span>
                                        </div>
                                        <div v-if="showLengthError">
                                            <span class="text-danger">Comment is too long (maximum is 255 characters)</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mcc-dialog__footer">
                            <div class="mcc-button-group mcc-button-group--spaced">
                                <button type="button" class="mcc-button mcc-button--outline" @click="commentHideHandler()">Close</button>
                                <button type="button" class="mcc-button mcc-button--primary " @click="addComment($event)">Send comment</button></div>
                            </div>
                    </section>
                </form>
            </dialog>
        </div>
    </div>
</template>

<script>
import MyTaskListAPI from "@/services/MyTaskListAPI";
import Table from "@advanced/component-mosaic-table";
import constantMessages from "@/messages";
import Utils from "@/script_utils";
import {
    EventBus
} from "@/services/event-bus";

export default {
    props: ['taskId', 'users', 'taskObj'],
    created() {
        this.getComments(false);
    },
    data() {
        return {
            taskEventData: [],
            comments: [],
            message: '',
            updateCall: true,
            updateComments: false,
            showError: false,
            showLengthError: false
        }
    },
    methods: {
        addComment(e) {
            let self = this;
            self.updateCall = false;
            let msgText = $(".note-editable")[0].innerText;
            let obj = {
                'message': msgText,
                'taskId': self.taskObj.taskId,
                'taskName': self.taskObj.taskName,
                'processId': self.taskObj.processId,
                'processInstanceId': self.taskObj.processInstanceId,
                'processName': self.taskObj.processName
            }

            if (msgText.trim() == '') {
                this.showError = true;
                self.updateCall = true;
                return;
            }
            if (msgText.trim() != '' && msgText.length > 255) {
                this.showLengthError = true
                self.updateCall = true;
                return;
            }
            if (msgText.trim() != '') {
                this.showError = false;
                this.showLengthError = false;
            }

            MyTaskListAPI.postComments(this.taskId, obj)
                .then(response => {
                    if (response.error) {
                        EventBus.$emit("error-notification", {
                            msg: constantMessages.MESSAGES[response.message]
                        });
                    } else {
                        self.comments = [];
                        EventBus.$emit("success-notification", {
                            msg: constantMessages.MESSAGES[response.message]
                        });
                        self.comments = response.data;
                        self.$emit('updateCommentCount', self.comments.length);
                    }
                })
                .finally(() => {
                    self.updateCall = true;
                    self.message = "";
                    self.$refs.commentsDialog.close();
                });
        },
        showCommentDialog() {
            this.$refs.commentsDialog.show();
            this.commentsShowHandler();
        },
        getFormattedAction(data) {
            if (data != null && data != "") {
                return data.replace(/([a-z](?=[A-Z]))/g, '$1 ');
            }
            return "";
        },
        getTaskEvents() {
            let self = this;
            MyTaskListAPI.getTaskEvents(this.taskId)
                .then(result => {
                    self.taskEventData = result.data;
                    for (let i = 0; i < self.taskEventData.length; i++) {
                        self.taskEventData[i]['messages'] = self.taskEventData[i].message.join(", ");
                        self.taskEventData[i]['action'] = self.getFormattedAction(self.taskEventData[i]['action'])
                    }
                })
                .finally(() => {
                    self.initTaskHistoryTable();
                });
        },
        getComments(loadSummernote) {
            let self = this;
            MyTaskListAPI.getComments(this.taskId)
                .then(result => {
                    self.comments = result;
                })
                .finally(() => {
                    self.$emit('updateCommentCount', self.comments.length);
                    if (loadSummernote) {
                        self.loadSummernote();
                    }
                });
        },
        loadSummernote() {
            this.updateComments = true;
            if (this.taskObj.isCompleted) {
                $("#chatInputEle").val("");
                let dialog = document.getElementById('comments-dialog');
                // disable the confirm
                dialog.enableConfirm(false);
                dialog.addEventListener('submit', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                })
                return;
            }
            $('.note-popover.popover').remove();
            this.initializeSummernote();
            $('.summernote').summernote('code', "");
        },
        commentsShowHandler() {
            this.getComments(true)
        },
        commentHideHandler() {
            $('.summernote').summernote('destroy')
            this.updateComments = false;
            this.showError = false;
            this.$refs.commentsDialog.close();
        },
        taskHistoryShowHandler() {
            this.getTaskEvents();
        },
        taskHistoryCloseHandler() {
            this.$refs.taskHistoryDialog.close();
            this.taskEventData = [];
        },
        initTaskHistoryTable() {
            let self = this;
            const table = document.getElementById("taskHistoryTableId");
            self.tableObj = window.tableFactory.create(table, {
                bordered: true,
                striped: true,
                emptyTemplate: '<p class="text-center m-0">No history found</p>',
                columnSearch: false,
                fixedHeight:true,
                pageSize: 10,
                debounceTime: 1000,
                totalCount: self.taskEventData.length,
                schema: {
                    properties: {
                        action: {
                            type: "string",
                            title: "Action",
                            sortable:true,
                        },
                        userId: {
                            type: "string",
                            title: "Taken by",
                            sortable:true,
                        },
                        messages: {
                            type: "string",
                            title: "Message",
                            sortable:true,
                        },
                        actionTime: {
                            type: "string",
                            title: "When",
                            sortable:true,
                        },
                    }
                },
                data: () => {
                    return self.taskEventData;
                },
            });
        },
        initializeSummernote() {
            let arrayOfUserNames = this.users.map(a => a.username)
            $('.summernote').summernote({
                toolbar: false,
                tabSize: 0,
                height: 100,
                disableResizeEditor: true,
                placeholder: "Type your message",
                callbacks: {
                    onInit: function () {
                        Utils.bindSummerNoteHintPatch();
                    },
                    onKeyup: function (e) {
                        if (e.keyCode == 13) {
                            e.preventDefault();
                        } else if (e.keyCode != 27) {
                            e.stopPropagation();
                        }
                    },
                    onKeydown: function (e) {
                        if (e.keyCode == 13) {
                            e.preventDefault();
                        } else if (e.keyCode != 27) {
                            e.stopPropagation();
                        }
                    }
                },
                hint: {
                    mentions: arrayOfUserNames,
                    match: /\B@(\w*)$/,
                    search: function (keyword, callback) {
                        callback($.grep(this.mentions, function (item) {
                            return item.indexOf(keyword) == 0;
                        }));
                    },
                    content: function (item) {
                        return '@' + item;
                    }
                }
            });
            $('.note-statusbar').hide();
        },
        showTaskHistoryCommentDialog() {
            this.$refs.taskHistoryDialog.show();
            this.taskHistoryShowHandler();
        }
    }
}
</script>

<style scoped>
.sub-title {
    border-bottom: 1px solid rgba(204, 204, 204, 0.35);
    padding-bottom: 10px;
    margin-bottom: 20px;
}

.chat__body {
    max-height: 450px;
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    flex-direction: column-reverse;
}

mosaic-textarea#chatInputEle {
    display: none !important;
}
</style>
